/**
 * B-8: inicjal na awatarze. Jeden wyraz to JEDNA litera ("admin" -> "A"), dwa i wiecej
 * to pierwsza litera pierwszego i ostatniego wyrazu ("Jan Kowalski" -> "JK").
 * Maksymalnie dwa znaki.
 *
 * Wyrazem jest ciag, w ktorym jest litera albo cyfra, a inicjalem pierwsza taka litera (cyfra):
 * nazwa mowcy z rola w nawiasie ("Jakub (techniczny)") albo z myslnikiem ("Anna - handlowiec")
 * nie moze dac awatara "J(" ani "A-".
 */
export function inicjaly(nazwa: string): string {
  const wyrazy = (nazwa || "")
    .trim()
    .split(/\s+/)
    .map((w) => w.match(/[\p{L}\p{N}]/u)?.[0])
    .filter((znak): znak is string => znak !== undefined);
  if (wyrazy.length === 0) return "?";
  if (wyrazy.length === 1) return wyrazy[0].toUpperCase();
  return (wyrazy[0] + wyrazy[wyrazy.length - 1]).toUpperCase();
}
